/**
 * IndexedDB offline storage for Archon.
 * Stores pending requests when offline, syncs when back online.
 */

const DB_NAME = "archon-offline";
const DB_VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains("pendingRequests")) {
        db.createObjectStore("pendingRequests", { keyPath: "id", autoIncrement: true });
      }
      if (!db.objectStoreNames.contains("cachedData")) {
        db.createObjectStore("cachedData", { keyPath: "key" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

const offlineStore = {
  async addPendingRequest(url, method, body) {
    const db = await openDB();
    const tx = db.transaction("pendingRequests", "readwrite");
    tx.objectStore("pendingRequests").add({
      url, method, body,
      timestamp: Date.now(),
      synced: false,
    });
  },

  async getPendingCount() {
    try {
      const db = await openDB();
      const tx = db.transaction("pendingRequests", "readonly");
      return new Promise((resolve) => {
        const req = tx.objectStore("pendingRequests").count();
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => resolve(0);
      });
    } catch { return 0; }
  },

  async getPendingRequests() {
    const db = await openDB();
    const tx = db.transaction("pendingRequests", "readonly");
    return new Promise((resolve) => {
      const req = tx.objectStore("pendingRequests").getAll();
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => resolve([]);
    });
  },

  async clearSynced() {
    const db = await openDB();
    const tx = db.transaction("pendingRequests", "readwrite");
    tx.objectStore("pendingRequests").clear();
  },

  async cacheData(key, data) {
    const db = await openDB();
    const tx = db.transaction("cachedData", "readwrite");
    tx.objectStore("cachedData").put({ key, data, timestamp: Date.now() });
  },

  async getCachedData(key) {
    try {
      const db = await openDB();
      const tx = db.transaction("cachedData", "readonly");
      return new Promise((resolve) => {
        const req = tx.objectStore("cachedData").get(key);
        req.onsuccess = () => resolve(req.result?.data || null);
        req.onerror = () => resolve(null);
      });
    } catch { return null; }
  },
};

// Make globally available for SyncStatus component
window.archonOfflineStore = offlineStore;

export default offlineStore;
